import {useAppSelector} from "./store";
import {AlertNotificationsState} from "../store/alertNotifications";

export const useAlertNotifications = () => {
  return useAppSelector<AlertNotificationsState>(state => state.alertNotifications).notifications;
};